import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=ed277194&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"
import style0 from "./AppMenu.vue?vue&type=style&index=0&id=ed277194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed277194",
  null
  
)

export default component.exports